var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZecIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000182502270863680303330000005579778370205863614_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000134216061710896173170000011911388830524642491_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 714.3419,
    y1: 671.9496,
    x2: 720.1579,
    y2: 671.9496,
    gradientTransform: "matrix(86.5569 -86.5569 -86.5569 -86.5569 -3478.4458 120689.1016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CF8724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDCE58"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.1,810.4c-200.8,0-364.7-164.1-364.7-364.7C76.4,244.9,240.5,81,441.1,81 c200.8,0,364.7,164.1,364.7,364.7C805.8,646.5,641.9,810.4,441.1,810.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M441.1,881.7C198.8,881.7,0.5,683.4,0.5,441.1S198.8,0.5,441.1,0.5s440.6,198.3,440.6,440.6S683.4,881.7,441.1,881.7z  M441.1,98.5c-188.4,0-342.6,154.2-342.6,342.6s154.2,342.6,342.6,342.6s342.6-154.2,342.6-342.6S629.5,98.5,441.1,98.5 L441.1,98.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M413,560.5h190.9v95.5H491.3v80.8h-98v-78.3H275.8c0-31.9-4.8-63.6,2.5-93c2.5-14.7,19.5-29.4,31.9-44.1 c36.7-44.1,73.4-88.1,112.7-132.2c14.7-17.2,29.4-31.9,46.6-51.4H285.8v-95.5h107.6v-80.8h95.5v78.3h117.5c0,31.9,4.8,63.6-2.5,93 c-2.5,14.7-19.5,29.4-31.9,44.1C535.3,420.9,498.6,465,459.4,509C444.7,526.2,430,543.3,413,560.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZecIcon);
export default __webpack_public_path__ + "static/media/zec_icon.e4a1c3abcdac9e3b07198cb6cc31d5f7.svg";
export { ForwardRef as ReactComponent };